<template>
  <!-- <v-layout>
      <h1>Fixed Cost #{{$route.params.id}}</h1>
  </v-layout>-->
  <v-layout pl-2 pt-2 pr-2 pb-2 justify-center row>
    <v-flex xs2>
      <SimpleCard>
        <DriverSignupEntrySearchBox @search="search" @clear="clear" :query="query"></DriverSignupEntrySearchBox>
      </SimpleCard>
    </v-flex>
    <v-flex xs10 pl-2>
      <SimpleCard>
        <v-layout row wrap align-content-center justify-center>
          <v-flex v-if="loading" xs12 pa-2 class="text-xs-center">
            <v-progress-circular :size="48" :width="5" color="primary" indeterminate></v-progress-circular>
          </v-flex>
          <DriverSignupEntryList
            v-if="!loading"
            style="width: 100%;"
            :driverSignupEntries="driverSignupEntries"
            :paginationProp="pagination"
          ></DriverSignupEntryList>
          <v-flex v-if="!loading" pt-2 xs9 class="text-xs-center pt-2">
            <v-pagination @input="changePage" v-model="pagination.page" :length="numPages"></v-pagination>
          </v-flex>
        </v-layout>
      </SimpleCard>
    </v-flex>
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import DriverSignupEntryList from "@/components/driver/DriverSignupEntryList.vue";
import DriverSignupEntrySearchBox from "@/components/driver/DriverSignupEntrySearchBox.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "drivers",
  components: {
    SimpleCard,
    DriverSignupEntryList,
    DriverSignupEntrySearchBox
  },
  data: function() {
    return {
      offset: 0,
      count: 20,
      query: {
        rejected: null,
        submitted: false,
        status: "All"
      },
      loading: true,
      pagination: { page: 1 },
      numPages: 0,
      driverSignupEntries: []
    };
  },
  mounted: async function() {
    this.getDrivers();
  },
  methods: {
    search: function() {
      this.pagination.page = 1;
      this.getDrivers();
    },
    clear: function() {
      this.query = {
        search: "",
        lockedOut: false
      };
    },
    changePage: function(page) {
      this.pagination.page = page;
      this.getDrivers();
    },
    getDrivers: async function() {
      this.loading = true;

      try {
        var url = `${this.$store.state.apiUrl}/driver_signup/list?offset=${this
          .count *
          (this.pagination.page - 1)}&count=${this.count}&submittedOnly=${
          this.query.submitted
        }`;

        if (this.query.status == "Accepted") {
          url += "&rejected=false";
        } else if (this.query.status == "Rejected") {
          url += "&rejected=true";
        }

        let response = await axios.get(url, {
          params: {}
        });

        var driverSignupEntries = response.data.driverSignupEntries;

        this.driverSignupEntries = driverSignupEntries;

        this.pagination.page = response.data.page;
        this.numPages = response.data.numPages;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get drivers " + error);
      }
    },
    failed: function(data) {
      alert("Request Failed with error: " + data.message);
    }
  }
};
</script>
